import { Component } from '@angular/core';
import { BaseListDirective } from 'src/app/directives/base-list.directive';
import { PrimeNGTableColumn } from 'src/app/models/AppGenericClasses';

@Component({
  selector: 'app-state-list',
  templateUrl: './state-list.component.html',
  styleUrls: ['./state-list.component.sass']
})
export class StateListComponent extends BaseListDirective {

  override availableColumns: PrimeNGTableColumn[] = [
    new PrimeNGTableColumn('name_', 'CORE.STATE', 1000, { frozen: true }),
  ];
  override title = 'MENU.STATES';
  override filterableFields = ['name_']
  override keys = {
    primary_key: 'state_id',
    label: 'name_'
  }
  override filename = 'MENU.STATES';

  override getList(): void {
    this.query(this.data.core.states()).subscribe()
  }

  override handleRows(data: any): void {
    super.handleRows(data);

  }

  override refreshActionServices(): void {
    this.inactivationService = this.data.core.stateDelete(
      this.itemSelected[this.keys.primary_key]
    )
  }
}

